import { jsx as n, jsxs as i } from "react/jsx-runtime";
import { useRef as b, useState as m, useCallback as g, useEffect as c } from "react";
import { useChatbotContext as w } from "../../hooks/useChatbotContext.js";
function B({
  children: a,
  ...u
}) {
  const {
    cn: s,
    disableAutoScroll: d,
    handleScroll: f,
    isPopup: h,
    isReadonly: p
  } = w(), t = b(null), [r, v] = m(!0), l = g(() => {
    const e = t.current, o = e ? e.scrollHeight - e.scrollTop - e.clientHeight < 50 : !0;
    v(o);
  }, []);
  return c(() => {
    const e = t.current;
    if (!e) return;
    const o = new MutationObserver(() => {
      r && e.scrollTo({
        top: e.scrollHeight,
        behavior: "smooth"
      });
    });
    return o.observe(e, { childList: !0, subtree: !0 }), () => o.disconnect();
  }, [r]), c(() => {
    const e = t.current;
    if (e)
      return e.addEventListener("scroll", l), () => {
        e.removeEventListener("scroll", l);
      };
  }, [l]), /* @__PURE__ */ n(
    "div",
    {
      className: s(
        "relative flex min-h-0 grow flex-col [&>button]:hidden [&>div]:flex [&>div]:w-full [&>div]:flex-col [&>div]:gap-5",
        {
          "h-screen": h
        }
      ),
      ...u,
      children: /* @__PURE__ */ i("div", { className: "custom-scrollbar h-full overflow-y-auto", ref: t, children: [
        a,
        p ? null : /* @__PURE__ */ n("div", { className: "pointer-events-none sticky inset-0 flex justify-center", children: /* @__PURE__ */ i(
          "button",
          {
            disabled: r,
            className: s(
              "absolute bottom-0 mb-5 inline-flex scale-100 cursor-pointer flex-row items-center rounded-full border border-border bg-card p-2.5 text-card-foreground shadow shadow-primary/10 ring ring-transparent ring-offset-0 drop-shadow-[0_15px_25px_rgba(0,0,0,0.02)] transition hover:scale-105 focus-visible:scale-105 focus-visible:outline-none focus-visible:ring-ring disabled:cursor-wait disabled:hover:ring-transparent",
              {
                "pointer-events-none opacity-0": r,
                "pointer-events-auto opacity-100": !r
              }
            ),
            type: "button",
            onClick: (e) => {
              if (!d) {
                const o = t.current;
                o && o.scrollTo({
                  top: o.scrollHeight,
                  behavior: "smooth"
                });
              }
              f(e);
            },
            children: [
              /* @__PURE__ */ n(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  height: 22,
                  width: 22,
                  name: "arrowBigDown",
                  "aria-label": "Jump to latest",
                  children: /* @__PURE__ */ n(
                    "path",
                    {
                      fill: "currentColor",
                      d: "m11 16.86-6-5.04v2.62l7 5.86 7-5.86v-2.62l-6 5.04V4h-2v12.86Z"
                    }
                  )
                }
              ),
              /* @__PURE__ */ n("span", { className: "sr-only", children: "Jump to latest" })
            ]
          }
        ) })
      ] })
    }
  );
}
export {
  B as ScrollWrapper
};
